import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {camelizeKeys, decamelizeKeys} from 'humps'
import {useSelector} from 'react-redux'

export enum StateTabKey {
  // 摩洛哥
  // Morocco = 212,
  // // 阿曼
  // Oman = 968,
  // 阿联酋
  UAE = 971,
  // 印度
  INDIAN = 91,
}

export enum TabKey {
  rank = 'rank',
  rule = 'rule',
}

export const getConifg = createAsyncThunk(
  'live/activity/national_day_flag',
  async (stateKey: StateTabKey, store) => {
    const resp = await http.post<HiyaRes<InitialStateType>>(
      'live/activity/national_day_flag',
      {
        region_code: stateKey,
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data
  }
)

interface InitialStateType {
  stateKey: StateTabKey
  // 当前分数
  current_score?: number
  // 倒计时
  activity_expire?: number
  // 活动id
  activity_id?: number
  // 分数组
  jump_score_list?: number[]
}

const initialState: InitialStateType = {
  stateKey: StateTabKey.INDIAN,
}

export const RaiseAFlagSlice = createSlice({
  name: 'RaiseAFlag',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getConifg.pending, (state, action) => {
      return {
        stateKey: action.meta.arg,
      }
    })
    builder.addCase(getConifg.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state, data)
    })
  },
})
export default RaiseAFlagSlice.reducer
export const useRaiseAFlagState = () => {
  const data = useSelector((state) => state.RaiseAFlag)
  return data
}
